<label [class]="wrapperClasses">
  <input
    type="checkbox"
    [class]="inputClasses"
    [checked]="checked"
    [disabled]="disabled"
    [attr.aria-label]="computedAriaLabel"
    (change)="onChange($event)"
    />

  @if (label) {
    <span class="label-text">{{ label }}</span>
  }
  <ng-content></ng-content>
</label>

